module.exports = __webpack_public_path__ + "img/joel-make-time1.4abf66e5.png";